import { render } from "./contactdemo.vue?vue&type=template&id=efbb9048&scoped=true"
import script from "./contactdemo.vue?vue&type=script&lang=js"
export * from "./contactdemo.vue?vue&type=script&lang=js"

import "./contactdemo.vue?vue&type=style&index=0&id=efbb9048&lang=css"
import "./contactdemo.vue?vue&type=style&index=1&id=efbb9048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbb9048"]])

export default __exports__